import { Pipe, PipeTransform } from '@angular/core';
import { SearchProductLabel } from '@epicuro-next/models/products';
import { ProductLabel } from 'graphql-api/gql-api-interfaces';

@Pipe({
  name: 'filterLabelsByName',
  pure: true,
  standalone: true,
})
export class FilterLabelsByNamePipe implements PipeTransform {
  public transform(
    labels: (SearchProductLabel | ProductLabel)[],
    filteredNames: string[] | string,
  ): ProductLabel[] {
    if (!filteredNames) {
      return labels as ProductLabel[];
    }

    const lowerCaseFilteredNames = (
      Array.isArray(filteredNames) ? filteredNames : [filteredNames]
    ).map((v) => v.toLowerCase());
    return labels.filter(
      (label) => !lowerCaseFilteredNames.includes(label.name.toLowerCase()),
    ) as ProductLabel[];
  }
}
